import React, { forwardRef, memo } from 'react'

const ProIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="47.6"
      height="48.3"
      viewBox="0 0 47.6 48.3"
      fill="none"
      {...props}>
      <circle cx="23.8" cy="24.1353" r="23.8" fill="#78BE20" />
      <g
        stroke="white"
        strokeWidth="2.259"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M32.0383 26.8815H15.5613a.686.686 0 0 0-.6864.6864v2.0597c0 .3791.3073.6863.6864.6863h16.477c.3791 0 .6864-.3072.6864-.6863v-2.0597c0-.3791-.3073-.6864-.6864-.6864Z" />
        <path d="M21.7403 26.8814V16.5833c0-.182.0723-.357.2011-.4858a.686.686 0 0 1 .4858-.2011h2.7457c.182 0 .357.0723.4858.2011.1288.1288.2011.3038.2011.4858v10.2981" />
        <path d="M31.3518 26.8817V24.822a6.826 6.826 0 0 0-5.4921-6.9678" />
        <path d="M16.248 26.8817V24.822a6.826 6.826 0 0 1 5.4921-6.9678" />
      </g>
    </svg>
  )
)

ProIcon.displayName = 'ProIcon'

export default memo(ProIcon)
